<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Onay Türü</label>
            <v-select-list :options="requiredConfirmationTypes" label="name" v-model="requiredConfirmationType" placeholder="Onay Türü"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Unvan</label>
            <v-select-list :options="titles" label="Combine" v-model="title" placeholder="Unvan"></v-select-list>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import HumanResourcesParametersApi from '@/api/human-resources-parameters'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            titles:[],
            requiredConfirmationTypes:[
                {name:'Tek kullanıcı onayı yeterli.',value:0},
                {name:'Tüm kullanıcıların onayı gerekli.',value:1}
            ]
        }
    },
    mounted(){
        this.getTitles()
    },
    methods:{
        getTitles(){
            HumanResourcesParametersApi.EmployeeDepartmentTitle.ListAll().then(res=>{
                this.titles = (res.data?.Data || [])?.map(r => ({...r,Combine:[r.BranchName,r.Name].join(' - ')}))
            })
        },
    },
    computed:{
        title:{
            get:function(){
                return this.titles.find(b=>b.Id==this.value.EmployeeDepartmentTitleId)
            },
            set:function(value){
                this.value.EmployeeDepartmentTitleId = value?.Id || null
            }
        },
        requiredConfirmationType:{
            get:function(){
                return this.requiredConfirmationTypes.find(b=>b.value==this.value.RequiredConfirmationType)
            },
            set:function(value){
                this.value.RequiredConfirmationType = value?.value >= 0 ? value.value : null
            }
        },
    }
}
</script>